import axios from "axios"

const axiosIns = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
})

export default axiosIns
